import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  title = 'app';
  year: number = (new Date()).getFullYear();
 
  constructor() { } 
 
} 
